import { classNames, tv } from "@opensea/ui-kit"
import { marginVariants } from "@/styles/utils/margin"

export const MAX_COLLECTIONS = 3
export const TABLE_ROW_CLASS_NAMES = classNames(
  marginVariants({ variant: "negative" }),
  "bg-transparent",
)

export const tableRowColumns = tv({
  slots: {
    collection: "",
    held: "w-[55px] justify-end",
    value: "w-[120px] justify-end",
  },
})()
